import React from 'react';

interface CommonProps {
    node?: any;
    children?: React.ReactNode;
    handleCopy?: any;
}

export const UnorderedList: any = ({...props}) => (
    <ul className="list-disc ml-7 flex flex-col" {...props} />
);

export const OrderedList: any = ({...props}) => (
    <ol className="list-decimal ml-7 flex flex-col" {...props} />
);

export const ListItem: React.FC<CommonProps> = ({handleCopy, ...props}) => (
    <li className="mb-2" onCopy={handleCopy} {...props} />
);

export const Heading1: React.FC<CommonProps> = ({handleCopy, ...props}) => (
    <h1 className="text-3xl font-bold mb-4 text-center" onCopy={handleCopy} {...props} />
);

export const Heading2: React.FC<CommonProps> = ({handleCopy, ...props}) => (
    <h2 className="text-2xl font-bold mb-3 text-center" onCopy={handleCopy} {...props} />
);

export const Heading3: React.FC<CommonProps> = ({handleCopy, ...props}) => (
    <h3 className="text-xl font-bold mb-2 text-center" onCopy={handleCopy} {...props} />
);

export const Heading4: React.FC<CommonProps> = ({handleCopy, ...props}) => (
    <h4 className="text-lg font-bold mb-1 text-center" onCopy={handleCopy} {...props} />
);

export const Heading5: React.FC<CommonProps> = ({handleCopy, ...props}) => (
    <h5 className="text-base font-bold mb-1 text-center" onCopy={handleCopy} {...props} />
);

export const Heading6: React.FC<CommonProps> = ({handleCopy, ...props}) => (
    <h6 className="text-sm font-bold mb-1 text-center" onCopy={handleCopy} {...props} />
);

export const Blockquote: React.FC<CommonProps> = ({handleCopy, ...props}) => (
    <blockquote className="border-l-4 border-neutral-500 pl-4 py-2 my-4" onCopy={handleCopy} {...props} />
);

export const Paragraph: React.FC<CommonProps> = ({children, handleCopy, ...props}) => (
    <p className="whitespace-pre-line" onCopy={handleCopy} {...props}>
        {children}
    </p>
);

export const TableHead: any = ({...props}) => (
    <thead className="border-b border-neutral-400 dark:border-neutral-700" {...props} />
);

export const TableHeader: any = ({...props}) => (
    <th
        scope="col"
        className="px-2 py-1 text-left text-xs font-medium uppercase tracking-wider max-w-xs whitespace-normal text-neutral-800 dark:text-neutral-200"
        {...props}
    />
);

export const TableBody: any = ({...props}) => (
    <tbody className="divide-y divide-neutral-400 dark:divide-neutral-700" {...props} />
);

export const TableCell: any = ({...props}) => (
    <td className="px-2 py-1 max-w-xs whitespace-normal text-neutral-700 dark:text-neutral-300" {...props} />
);